export default function parseTries(tries) {
    let trie
    for (let element of tries) {
        if (["done", "in_progress", "failed"].includes(element.status_code)) {
            trie = element
            break
        } else {
            trie = element
        }
    }
    return trie
}